import { Box, BoxProps, useTheme } from "@mui/material";
import { Text } from "../../core-ui/components/Text/Text";

export const BetaChip = (props: BoxProps) => {
  const theme = useTheme();
  return (
    <Box
      mt={0.25}
      borderRadius={(theme) => theme.border.radius.xs}
      border={(theme) => `solid 1px ${theme.palette.primary.main}`}
      padding={(theme) => theme.spacing(0, 0.5)}
      sx={(theme) => ({
        backgroundColor:
          theme.palette.customColor.projectWorkflowMessageBackgroundColor,
      })}
      {...props}
    >
      <Text bold color={theme.palette.primary.main}>
        BETA
      </Text>
    </Box>
  );
};
